<template>
  <div
    :style="$route.meta.isEmbed ? {} :
    {position: 'sticky',
    top:'50px'} "
    style="
    background: #F5FAFD;
    z-index: 1;
">
    <!--    FILTERS-->
    <div class="filters-container">
      <!--      REGION-->
      <b-select
        v-model="selection.region" :options="regionOptions"
      />
      <!--      COUNTRY-->
      <b-select
        v-model="selection.country" :options="countryOptions"
      />


      <!--      SECTOR-->
      <b-select
        v-model="selection.sector" :options="sectorOptions"
      />


      <!--      YEAR-->
      <b-select
        v-model="selection.year" :options="yearOptions"
      />


      <!--      ACTIVITY-->
      <b-select
        v-model="selection.activity" :options="activityOptions"
      />
<!--
      &lt;!&ndash;      TYPES&ndash;&gt;
      <b-select
        v-model="selection.type" :options="typeOptions"
      />-->

      <!--      SIZE-->
      <b-select
        v-model="selection.size" :options="sizeOptions"
      />
    </div>

    <!--    END FILTERS-->
  </div>
</template>

<script>
import {axiosCall} from "@/utils/axiosCall";
import DashboardPie from "@/components/modules/dashboard/components/generic-charts/dashboard-pie.vue";
import DashboardGender from "@/components/modules/dashboard/components/generic-charts/dashboard-gender.vue";
import DashboardChartVertical
  from "@/components/modules/dashboard/components/generic-charts/dashboard-chart-vertical.vue";
import DashboardStatusTemp from "@/components/modules/dashboard/components/generic-charts/dashboard-status-temp.vue";
import DashboardStatus from "@/components/modules/dashboard/components/generic-charts/dashboard-status.vue";
import BarChart from "@/shared/charts/bar-char/bar-chart.vue";
import {mapGetters} from "vuex";

export default {
  name: "TrackerDashboardFilters",
  data: function () {
    return {
      dashboardFiltersData: [],
      yearOptions:[],
      regionOptions:[],
        countryOptions:[],
        sectorOptions:[],
      activityOptions:[],
      sizeOptions:[],
      typeOptions:[],
      selection: {
        sector: null,
        year: null,
        country: null,
        activity: null,
        size: null,
        region: null,
        type:null
      },
    };
  },
  watch: {
    selection: {
      handler:  function () {
        this.$store.dispatch('SET_NEW_TRACKER_FILTERS', {...this.selection});
        this.fetchFilters();
      },
      deep: true,
    },
    getLang: function () {
      this.formatRegionOptions();
      this.formatYearOptions();
      this.formatCountryOptions();
      this.formatActivityOptions();
      this.formatSizeOptions();
      this.formatSectorOptions();
      this.formatTypeOptions();
    }
  },

  async mounted() {
    await this.fetchFilters();
  },
  computed: {
    ...mapGetters([
      "getLang",
    ]),
  },
  methods: {
    formatRegionOptions() {
      this.regionOptions =[
        {text: this.$t("label_dashboard_filterBy_region"), value: null},
        ...(this.dashboardFiltersData.region || [])
          .filter((region) => !!region?.id)
          .map((region) => ({
            value: region.id,
            text: this.$t(region.name),
          }))
          .sort((sizeA, sizeB) => sizeA.text.localeCompare(sizeB.text)),
      ];
    },
    formatYearOptions() {
      // YEAR
      this.yearOptions = [
        {text: this.$t("label_dashboard_filterBy_year"), value: null},
        ...(this.dashboardFiltersData.year || []).sort().map((year) => ({
          text: year,
          value: year,
        })),
      ];
    },
    formatCountryOptions() {
      // COUNTRY
      this.countryOptions= [
        {text: this.$t("label_dashboard_filterBy_country"), value: null},

        ...(this.dashboardFiltersData.country || [])
          .map((country) => ({
            value: country.id,
            text: this.$t(country.name),
          }))
          .sort((countryA, countryB) =>
            countryA.text.localeCompare(countryB.text)
          ),
      ];
    },
    formatActivityOptions() {
      // ACTIVITY
      this.activityOptions= [
        {text: this.$t("label_dashboard_filterBy_activity"), value: null},

        ...(this.dashboardFiltersData.activity || [])
          .filter((activity) => !!activity)
          .map((activity) => ({
            value: activity,
            text: this.$t(activity),
          }))
          .sort((activityA, activityB) =>
            activityA.text.localeCompare(activityB.text)
          ),
      ];

    },
    formatSizeOptions() {
      // SIZE
      this.sizeOptions= [
        {text: this.$t("label_dashboard_filterBy_size"), value: null},
        ...(this.dashboardFiltersData.size || [])
          .filter((size) => !!size)
          .map((size) => ({
            value: size,
            text: this.$t(size),
          }))
          .sort((sizeA, sizeB) => sizeA.text.localeCompare(sizeB.text)),
      ];

    },
    formatSectorOptions() {
      // SIZE
      this.sectorOptions= [
        {
          text: this.$t("label_dashboard_filterBy_sector"), value: null},
        ...(this.dashboardFiltersData.sector || [])
          .filter((size) => !!size)
          .map((size) => ({
            value: size,
            text: this.$t(size),
          }))
          .sort((sizeA, sizeB) => sizeA.text.localeCompare(sizeB.text)),
      ];
    },
    formatTypeOptions() {
      // SIZE
      this.typeOptions= [
        {
          text: this.$t("label_dashboard_filterBy_type"), value: null},
        ...(this.dashboardFiltersData.type || [])
          .filter((size) => !!size)
          .map((size) => ({
            value: size,
            text: this.$t(size),
          }))
          .sort((sizeA, sizeB) => sizeA.text.localeCompare(sizeB.text)),
      ];
    },
    fetchFilters: async function () {
      var dashboardFiltersData = await axiosCall({
        url: "tracker-dashboard/get-filter-options",
        method: "POST",
        data: this.selection
      });

      this.dashboardFiltersData.region = dashboardFiltersData.data[0].region;
      this.dashboardFiltersData.year = dashboardFiltersData.data[0].year;
      this.dashboardFiltersData.country = dashboardFiltersData.data[0].country;
      this.dashboardFiltersData.activity = dashboardFiltersData.data[0].activity;
      this.dashboardFiltersData.size = dashboardFiltersData.data[0].size;
      this.dashboardFiltersData.sector = dashboardFiltersData.data[0].sector;
      this.dashboardFiltersData.type = dashboardFiltersData.data[0].type;

      this.formatRegionOptions();
      this.formatYearOptions();
      this.formatCountryOptions();
      this.formatActivityOptions();
      this.formatSizeOptions();
      this.formatSectorOptions();
      this.formatTypeOptions();
    },
  },
};
</script>

<style lang="scss" scoped>
.filters-container {
  display: flex;
  gap: 15px;
  padding-top: 20px;
  padding-bottom: 20px;
  flex-wrap: wrap;

  > * {
    flex-basis: 200px;
    flex-grow: 0;
  }

  justify-content: center;
}

.widget-container {
  display: flex;
  flex-direction: column;
  border: 1px solid #1e4381;
  background-color: #f8fcff;
  color: black;
  height: 100%;
}

.widget-title {
  background-color: #1e4381;
  text-align: center;
  font-size: 1rem;
  color: white;
  text-transform: uppercase;
  font-weight: bold;
  font-family: "Poppins-SemiBold";
  padding: 5px 0;
}

.widget-title-gbv {
  background-color: #7030A0;
  text-align: center;
  font-size: 1rem;
  color: white;
  text-transform: uppercase;
  font-weight: bold;
  font-family: "Poppins-SemiBold";
  padding: 5px 0;
}

.widgets-outer-padding {
  padding: 20px;
}

.widgets-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  max-width: 1450px;
  margin: 0 auto;
  justify-content: center;

  > * {
    flex-basis: calc(100% / 3);
    max-width: calc(100% / 3);
    flex-grow: 0;
    flex-shrink: 0;
    height: auto;
  }

  @media screen and (max-width: 1350px) {
    > * {
      flex-basis: calc(100% / 2);
      max-width: calc(100% / 2);
      flex-grow: 0;
      flex-shrink: 0;
      height: auto;
    }
  }

  @media screen and (max-width: 1000px) {
    > * {
      flex-basis: calc(100%);
      max-width: 650px;
      flex-grow: 0;
      flex-shrink: 0;
      height: auto;
    }
  }
}

.dashboard-widget-center {
  padding: 15px 0px;
  height: 100%;
  display: flex;
  align-items: center;

  > * {
    flex-grow: 1;
    flex-basis: 100%;
  }
}
</style>

